import getI13nInstance from 'Lib/i13n';
import createI13nUtils, { type I13nUtils } from 'Lib/i13n/createI13nUtils';

/**
 * A helper function for using i13n utils outside of React.
 *
 * See docs/Instrumentation.md for more information.
 * Please use the useI13n hook from src/client/hooks/useI13n/index.ts inside React.
 */
function getI13nUtils(): I13nUtils {
  const instance = getI13nInstance();
  return createI13nUtils(instance.execute.bind(instance));
}

export default getI13nUtils;
